import {
  DEFAULT_SEARCH_FILTERS,
  extendDefaultFilterList,
} from 'bundles/search-common/components/filters/getFiltersList';
import { useShowCourseraTier } from 'bundles/search-common/providers/LearnerProvider';

const useFilterListOrder = (customDefaults?: string[]) => {
  const shouldShowCourseraPlusFilter = useShowCourseraTier();

  const defaultList = customDefaults || DEFAULT_SEARCH_FILTERS;
  return extendDefaultFilterList(defaultList, shouldShowCourseraPlusFilter);
};

export default useFilterListOrder;
